import gql from "graphql-tag";

export const GET_USER = gql`
  query getUser($id: ID!) {
    user(id: $id) {
      id
      email
      name
      lastName
      phoneNumber
      isActive
      roles
    }
  }
`;

export const CREATE_OR_UPDATE_USER = gql`
  mutation createOrUpdateUser(
    $id: ID
    $email: String!
    $name: String!
    $lastName: String
    $password: String!
    $phoneNumber: String
    $isActive: Boolean
    $roles: [String!]!
  ) {
    createOrUpdateUser(
      user: {
        id: $id
        password: $password
        roles: $roles
        isActive: $isActive
        email: $email
        phoneNumber: $phoneNumber
        lastName: $lastName
        name: $name
      }
    ) {
      id
    }
  }
`;

export const GET_STAFF = gql`
  query getStaff {
    staff {
      agents {
        id
        name
        lastName
        phoneNumber
      }
      managers {
        id
        name
        lastName
        phoneNumber
      }
    }
  }
`;
